module.exports = __webpack_public_path__ + "static/media/13.2387bd44.jpg";